<template>
  <v-dialog 
   v-model="$store.state.confirmDialog"  max-width="350">
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$store.commit('closeConfirmDialog')" color="secondary" text>
          {{ cancelText }}
        </v-btn>
        <v-btn @click="confirm" color="primary" text>
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
 
    title: { type: String, required: true },
    text: { type: String, required: true },
    confirmText: { type: String, required: true },
    cancelText: { type: String, required: true },
  },
 
  methods: {
   
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style>
</style>